import PropTypes from "prop-types";

import TabButton from "../formInputs/buttons/TabButton.jsx";

import * as styles from "../../styles/SemesterConnectedPanel.module.scss";
import "../../styles/OverviewSchoolYearSelect.scss";

/**
 * Year select + semester folder tabs connected to a panel body below.
 * @name SemesterConnectedPanel
 */
const SemesterConnectedPanel = ({
    options,
    selectedKey,
    onSchoolYearChange,
    selectedSemesterName,
    onSemesterChange,
    disableSecondTab = false,
    children
}) => {
    const isFirstSelected = selectedSemesterName === "1st Semester";
    const isSecondSelected = selectedSemesterName === "2nd Semester";
    const hasBody = children != null && children !== false;

    return (
        <div
            className={styles.root}
            data-testid="semester-connected-panel"
            data-selected-semester={selectedSemesterName}
            data-has-body={hasBody ? "true" : "false"}
        >
            <div className={styles.tabRow}>
                <label className={styles.schoolYearSelect}>
                    <span className="visually-hidden">School Year</span>
                    <select
                        aria-label="School Year"
                        className="overview-school-year-select"
                        value={selectedKey ?? ""}
                        onChange={onSchoolYearChange}
                        disabled={!options.length}
                    >
                        {options.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                </label>
                <div className={styles.tabs}>
                    <TabButton
                        className={isFirstSelected ? "folder-tab-selected" : "folder-tab"}
                        onClick={() => onSemesterChange("1st Semester")}
                        size="small-no-width"
                    >
                        <div>
                            <p className="primary">1st Semester</p>
                        </div>
                    </TabButton>
                    <TabButton
                        className={isSecondSelected ? "folder-tab-selected" : "folder-tab"}
                        disable={disableSecondTab}
                        onClick={() => onSemesterChange("2nd Semester")}
                        size="small-no-width"
                    >
                        <div>
                            <p className="primary">2nd Semester</p>
                        </div>
                    </TabButton>
                </div>
            </div>
            {hasBody ? (
                <div className={styles.panelBody} data-testid="semester-connected-panel-body">
                    {children}
                </div>
            ) : null}
        </div>
    );
};

SemesterConnectedPanel.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired
        })
    ).isRequired,
    selectedKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onSchoolYearChange: PropTypes.func.isRequired,
    selectedSemesterName: PropTypes.string.isRequired,
    onSemesterChange: PropTypes.func.isRequired,
    disableSecondTab: PropTypes.bool,
    children: PropTypes.node
};

export default SemesterConnectedPanel;
